import React from 'react'
import { Route, Routes } from 'react-router-dom';
import { Navbar, Footer, ScrollBar } from '../Component/index'
import {
    Home,
    About,
    Contact,
    Services,
    Solutions,
} from '../Screens/index'

import {
    HOME,
    ABOUT,
    SERVICE,
    CONTACT,
    SOLUTION,
} from './path'

const ROUTES = () => {
    return (
        <>
            <Navbar />
            <Routes>
                <Route path={HOME} element={<Home />} />
                <Route path={ABOUT} element={<About />} />
                <Route path={SERVICE} element={<Services />} />
                <Route path={CONTACT} element={<Contact />} />
                <Route path={SOLUTION} element={<Solutions />} />
            </Routes>
            <ScrollBar/>
            <Footer />
        </>
    )
}

export default ROUTES
